import store from '@/store';

import markList from '@/views/reports/pickers/add-marks/mark-list';
import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key, colors, treeView }: FormattersTypes) => {
  component.tag = 'span';

  let value = data[key] || '';
  let child = [ vtag('span', {domProps:{innerHTML: value}}, []) ];
  if((data.DT_RowMark || data.DT_RowMark === 0) && key.startsWith('reports-custom')) {
    const markData = markList.find((e) => +e.mark === +data.DT_RowMark);

    const icon = vtag('ui-icon', {
      class: [ 
        markData.class, 
        'mark-in-table'
      ],
      props: {
        color: colors[markData.color],
        size: 12,
        icon: markData.icon,
      }
    });

    child.unshift(icon);
  }

  return child
}
